import { observer } from 'mobx-react';
import * as React from 'react';
import {Component, useEffect, useState} from 'react';
import {Route, Switch} from "react-router";
import {bindRouter} from "@intelingu/core/utils/bindRouter";
import {SessionLayout} from "./pages/session/SessionLayout";
import {MainLayout} from "./MainLayout";
import {ProtectedRoute} from "./partials/ProtectedRoute";
import {AuthStore} from "../stores/AuthStore";
import {container, lazyInject} from "@intelingu/core/IoC/container";
import {observable} from "mobx";
import {LogoutPage} from "./pages/session/LogoutPage";
import {WorkspaceStore} from "../stores/WorkspaceStore";
import {useGetAllowedCoursesQuery} from "../types.d";

interface RouterProps {
}

declare const window;

const CourseWrapper = (props) => {
    const [ready, setReady] = useState<boolean>(false);
    const workspace = container.get(WorkspaceStore);
    const allowedCourses = useGetAllowedCoursesQuery({
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        if (!workspace.courseId && allowedCourses.data) {
            if (allowedCourses.data.allowedCourses.length) {
                workspace.courseId = allowedCourses.data.allowedCourses[0].id
            }
            setReady(true);
        }

        if (workspace.courseId && !ready) {
            setReady(true);
        }
    });

    if (ready) {
        return props.children;
    }

    return <h2>Loading...</h2>
}

@bindRouter
class ScrollToTop extends Component<any, any> {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    render() {
        return this.props.children
    }
}

@bindRouter
@observer export class Router extends Component<RouterProps, any> {

    @lazyInject(AuthStore) authStore: AuthStore;
    @lazyInject(WorkspaceStore) workspaceStore: WorkspaceStore;

    @observable isReady = false;

    async componentDidMount() {
        const courseId = localStorage.getItem("courseId");

        if (courseId) {
            this.workspaceStore.courseId = Number(courseId);
        }

        await this.authStore.initialize();
        this.isReady = true;
    }

    render() {
        if (!this.isReady) {
            return null;
        }

        return <>
            <CourseWrapper>
                <ScrollToTop>
                    <Switch>
                        <Route path={`/session`} component={SessionLayout} />
                        <Route path={`/logout`} component={LogoutPage} />
                        <ProtectedRoute path={`/`} component={MainLayout} />
                    </Switch>
                </ScrollToTop>
            </CourseWrapper>
        </>
    }

}
